<div>
  <p class="headline-4 title">{{ 'CONTACT_BANNER.TITLE' | translate }}</p>
  <p class="body-3">{{ 'CONTACT_BANNER.SUBTITLE' | translate }}</p>
</div>
<div>
  <dap-lib-button
    (click)="showContactOverlay = true"
    buttonSize="medium"
    variant="white-violet"
    data-analytics="contact-banner_contact"
    >{{ 'CONTACT_BANNER.CONTACT' | translate }}
  </dap-lib-button>
  <ssc-contact-overlay
    (overlayClosed)="showContactOverlay = false"
    [asPopup]="true"
    [showOverlay]="showContactOverlay"
  ></ssc-contact-overlay>
</div>
